<template src="./Footer.html">
</template>

<script>
import GitInfo from "@/gitInfo.json";

export default {
  name: "mainFooter",
  data() {
    return {
      gitInfo: GitInfo
    };
  },
  methods: {
    getVersion() {
      if (this.gitInfo.branch.startsWith("release/")) {
        return `v${this.gitInfo.branch.replace("release/","")}`;
      } else {
        return this.gitInfo.branch;
      }
    }
  }
};
</script>
